import { formatPluginName } from '../../../common';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { formatScopeName, formatViewName } from '../../utils/nameFormat';
export const removeStructurePluginStmtInstruction = `

`;
export const stmtRemoveStructurePlugin = (args) => {
    if (args.scopeName) {
        return `remove plugin ${args.pluginName} in ${args.viewName}.${args.scopeName};`;
    }
    return `remove plugin ${args.pluginName} in ${args.viewName};`;
};
export const removeStructurePluginHandler = createStructureStatementHandler({
    type: 'remove plugin',
    parse: line => {
        const match = /^remove plugin (?<pluginName>[\w-]+) in (?<viewName>\w+)(\.(?<scopeName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove plugin',
                pluginName: formatPluginName(match.groups.pluginName),
                viewName: formatViewName(match.groups.viewName),
                scopeName: match.groups.scopeName ? formatScopeName(match.groups.scopeName) : undefined,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.removePlugin({
            name: stmt.pluginName,
            viewName: stmt.viewName,
            scopeName: stmt.scopeName,
        }));
    },
});
//# sourceMappingURL=RemovePluginStmt.js.map